import type { AudienceForm } from '../types.ts';
import { filterNonEmptyGroups } from './filterNonEmptyGroups.ts';

export const filterNormalizedEmptyGroups = (
  normalized: AudienceForm['normalized_definition']
): AudienceForm['normalized_definition'] => {
  return {
    includes: {
      operator: normalized.includes.operator,
      groups: filterNonEmptyGroups(normalized.includes.groups),
    },
    excludes: {
      operator: normalized.excludes.operator,
      groups: filterNonEmptyGroups(normalized.excludes.groups),
    },
  };
};
